export enum HtmlType {
  SUBMIT = "submit",
  BUTTON = "button",
  RESET = "reset",
}
